<template>
    <div id="deskAppPanel">
        <popup ref="popup" type="center" @close="popClose">
            <div class="desk_app_panel">
                <div class="download_btn_line">
                    <a class="win_btn" href="https://deskapp.oss-cn-beijing.aliyuncs.com/%E9%A6%96%E9%80%89AI-win32-ia32.rar"></a>
                    <a class="mac_btn" href="https://deskapp.oss-cn-beijing.aliyuncs.com/%E9%A6%96%E9%80%89AI_x64.dmg"></a>
                </div>
                <div class="install_text">目前有<span>35298897</span>人成功安装到电脑桌面</div>
                <div class="server_btn_line">
                    <a href="">安装视频教程</a><a href="">会员专属客服</a>
                </div>
                <div class="close_btn" @click="popClose"></div>
            </div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    export default {
        components:{popup},
        data() {
            return {
                
            }
        },
        created() {
        
        },
        methods: {
            show(){
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
                let user_id = localStorage.getItem("user_id")||0;
                //埋点
                zjzBrowseRecord({user_id:user_id, mod_code:"p001"})
            },
            installNow(){
                deferredPrompt.prompt()
                this.popClose();
                let user_id = localStorage.getItem("user_id")||0;
                deferredPrompt.userChoice.then(function(e) {
                    if (e.outcome === 'dismissed'){
                        // 不允许
                        //埋点
                        zjzBrowseRecord({user_id:user_id, mod_code:"p003"})
                    } else {
                        // 允许
                        //埋点
                        zjzBrowseRecord({user_id:user_id, mod_code:"p002"})
                    }
                })
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .desk_app_panel{
        width: 380px;
        height: 454px;
        position: relative;
        background-image: url("./img/pc_app_bj.png");
        background-size: 100% 100%;
        padding-top: 294px;
        .download_btn_line{
            display: flex;
            justify-content: space-between;
            padding: 0 26px;
            a{
                display: block;
                width: 154px;
                height: 40px;
            }
        }
        .install_text{
            font-size: 13px;
            line-height: 63px;
            padding-bottom: 4px;
            color: #999;
            text-align: center;
            span{
                color: #3286fc;
                padding: 0 15px;
            }
        }
        .server_btn_line{
            display: flex;
            justify-content: space-between;
            padding: 0 26px;
            a{
                display: block;
                width: 150px;
                height: 32px;
                text-align: center;
                line-height: 32px;
                color: #999;
                border: 1px solid #ccc;
                border-radius: 4px;
            }
        }
        .close_btn{
            position: absolute;
            bottom: -61px;
            left: 50%;
            transform: translateX(-50%);
            width: 39px;
            height: 39px;
            background-image: url("./img/pwa_close.png");
            cursor: pointer;
            background-size: 100% 100%;
        }
    }
</style>